import { useLang } from '@/i18n';
import { getSolarRecommand } from '@/service/solar-calculator';
import gtm from '@/utils/gtm';
import FormatCurrencyLocal from 'eco-design-reliance/currency/FormatCurrencyLocal';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';

const C: React.FC = () => {
    const { locale = '' } = useRouter();
    const { t } = useLang('stream_ultra_x');
    const [active, setActive] = useState<number>(0);
    const tabs: string[] = [t('C_tab1'), t('C_tab2'), t('C_tab3')];
    const [items, setItems] = useState([[]]);
    const products_static: any[] = [
        {
            title: t('C_item1_title'),
            desc: t('C_item1_desc'),
            subs: [
                {
                    name: t('C_item1_list1_name'),
                    text: t('C_item1_list1_text'),
                },
                {
                    name: t('C_item1_list2_name'),
                    text: t('C_item1_list2_text'),
                },
                {
                    name: t('C_item1_list3_name'),
                    text: t('C_item1_list3_text'),
                },
            ],
            hoverImg: 'https://websiteoss.ecoflow.com/upload/image/1753685874156/3_1.jpg',
            productId: (() => {
                const map: any = {
                    eu: '10190226882903',
                    uk: '10015518458195',
                    de: '15391692128637',
                    fr: '10018948874587',
                    it: '14945864352120',
                    es: '10018948415835',
                };
                return map[locale] || undefined;
            })(),
            variantId: (() => {
                const map: any = {
                    eu: '51256414077271',
                    uk: '51451071201619',
                    de: '56505094373757',
                    fr: '51022409269595',
                    it: '55212983878008',
                    es: '51022414446939',
                };
                return map[locale] || undefined;
            })(),
            link_more: `https://${locale}.ecoflow.com/products/stream-ultra-x`,
        },
        {
            title: t('C_item2_title'),
            desc: t('C_item2_desc'),
            subs: [
                {
                    name: t('C_item2_list1_name'),
                    text: t('C_item2_list1_text'),
                },
                {
                    name: t('C_item2_list2_name'),
                    text: t('C_item2_list2_text'),
                },
                {
                    name: t('C_item2_list3_name'),
                    text: t('C_item2_list3_text'),
                },
            ],
            hoverImg: 'https://websiteoss.ecoflow.com/upload/image/1754315945742/2_2.jpg',
            productId: (() => {
                const map: any = {
                    eu: '10190226882903',
                    uk: '10015518458195',
                    de: '15391692128637',
                    fr: '9867284775259',
                    it: '14908494086520',
                    es: '9867268227419',
                };
                return map[locale] || undefined;
            })(),
            variantId: (() => {
                const map: any = {
                    eu: '51256462115159',
                    uk: '51563639472467',
                    de: '56505094406525',
                    fr: '50473476751707',
                    it: '55029657862520',
                    es: '50473428779355',
                };
                return map[locale] || undefined;
            })(),
            link_more: ['fr', 'es', 'it'].includes(locale)
                ? `https://${locale}.ecoflow.com/products/stream-ac-pro-ac`
                : `https://${locale}.ecoflow.com/products/stream-ultra-x`,
        },
        {
            title: t('C_item3_title'),
            desc: t('C_item3_desc'),
            subs: [
                {
                    name: t('C_item3_list1_name'),
                    text: t('C_item3_list1_text'),
                },
                {
                    name: t('C_item3_list2_name'),
                    text: t('C_item3_list2_text'),
                },
                {
                    name: t('C_item3_list3_name'),
                    text: t('C_item3_list3_text'),
                },
            ],
            hoverImg: 'https://websiteoss.ecoflow.com/upload/image/1753685875000/3_3.jpg',
            productId: (() => {
                const map: any = {
                    eu: '10190226882903',
                    uk: '10015518458195',
                    de: '15391692128637',
                    fr: '10018948874587',
                    it: '14945864352120',
                    es: '10018948415835',
                };
                return map[locale] || undefined;
            })(),
            variantId: (() => {
                const map: any = {
                    eu: '51256414110039',
                    uk: '51563639439699',
                    de: '56505094439293',
                    fr: '51022409335131',
                    it: '55212983943544',
                    es: '51022414512475',
                };
                return map[locale] || undefined;
            })(),
            link_more: `https://${locale}.ecoflow.com/products/stream-ultra-x`,
        },
        {
            title: t('C_item4_title'),
            desc: t('C_item4_desc'),
            subs: [
                {
                    name: t('C_item4_list1_name'),
                    text: t('C_item4_list1_text'),
                },
                {
                    name: t('C_item4_list2_name'),
                    text: t('C_item4_list2_text'),
                },
                {
                    name: t('C_item4_list3_name'),
                    text: t('C_item4_list3_text'),
                },
            ],
            hoverImg: 'https://websiteoss.ecoflow.com/upload/image/1754315945699/2_4.jpg',
            productId: (() => {
                const map: any = {
                    eu: '10190226882903',
                    uk: '10015518458195',
                    de: '15391692128637',
                    fr: '10018948874587',
                    it: '14945864352120',
                    es: '10018948415835',
                };
                return map[locale] || undefined;
            })(),
            variantId: (() => {
                const map: any = {
                    eu: '51386400244055',
                    uk: '51563639505235',
                    de: '56505715753341',
                    fr: '51022759493979',
                    it: '55213096763768',
                    es: '51022780367195',
                };
                return map[locale] || undefined;
            })(),
            link_more: `https://${locale}.ecoflow.com/products/stream-ultra-x`,
        },
        {
            title: t('C_item5_title'),
            desc: t('C_item5_desc'),
            subs: [
                {
                    name: t('C_item5_list1_name'),
                    text: t('C_item5_list1_text'),
                },
                {
                    name: t('C_item5_list2_name'),
                    text: t('C_item5_list2_text'),
                },
                {
                    name: t('C_item5_list3_name'),
                    text: t('C_item5_list3_text'),
                },
            ],
            hoverImg: 'https://websiteoss.ecoflow.com/upload/image/1754315945731/2_5.jpg',
            productId: (() => {
                const map: any = {
                    eu: '10000451240279',
                    uk: '9877380268371',
                    de: '15171689447805',
                    fr: '9867394908507',
                    it: '14908509258104',
                    es: '9867364106587',
                };
                return map[locale] || undefined;
            })(),
            variantId: (() => {
                const map: any = {
                    eu: '50511267955031',
                    uk: '50839891149139',
                    de: '55835416265085',
                    fr: '50473938485595',
                    it: '55029709603192',
                    es: '50473803448667',
                };
                return map[locale] || undefined;
            })(),
            link_more: `https://${locale}.ecoflow.com/products/stream-ultra-pro`,
        },
        {
            title: t('C_item6_title'),
            desc: t('C_item6_desc'),
            subs: [
                {
                    name: t('C_item6_list1_name'),
                    text: t('C_item6_list1_text'),
                },
                {
                    name: t('C_item6_list2_name'),
                    text: t('C_item6_list2_text'),
                },
                {
                    name: t('C_item6_list3_name'),
                    text: t('C_item6_list3_text'),
                },
            ],
            hoverImg: 'https://websiteoss.ecoflow.com/upload/image/1753685874359/3_6.jpg',
            productId: (() => {
                const map: any = {
                    eu: '10000451240279',
                    uk: '9877380268371',
                    de: '15171689447805',
                    fr: '9867394908507',
                    it: '14908509258104',
                    es: '9867364106587',
                };
                return map[locale] || undefined;
            })(),
            variantId: (() => {
                const map: any = {
                    eu: '51007260361047',
                    uk: '51245894238547',
                    de: '56202343612797',
                    fr: '50877471588699',
                    it: '55175654703480',
                    es: '50877741039963',
                };
                return map[locale] || undefined;
            })(),
            link_more: `https://${locale}.ecoflow.com/products/stream-ultra-pro`,
        },
        {
            title: t('C_item7_title'),
            desc: t('C_item7_desc'),
            subs: [
                {
                    name: t('C_item7_list1_name'),
                    text: t('C_item7_list1_text'),
                },
                {
                    name: t('C_item7_list2_name'),
                    text: t('C_item7_list2_text'),
                },
                {
                    name: t('C_item7_list3_name'),
                    text: t('C_item7_list3_text'),
                },
            ],
            hoverImg: 'https://websiteoss.ecoflow.com/upload/image/1753685875391/3_7.jpg',
            productId: (() => {
                const map: any = {
                    eu: '10000451273047',
                    uk: '9877313028435',
                    de: '15171608871293',
                    fr: '9867284775259',
                    it: '14908494086520',
                    es: '9867268227419',
                };
                return map[locale] || undefined;
            })(),
            variantId: (() => {
                const map: any = {
                    eu: '50510963605847',
                    uk: '50839544365395',
                    de: '55835191804285',
                    fr: '50473476751707',
                    it: '55029657862520',
                    es: '50473428779355',
                };
                return map[locale] || undefined;
            })(),
            link_more: `https://${locale}.ecoflow.com/products/stream-ac-pro-ac`,
        },
        {
            title: t('C_item8_title'),
            desc: t('C_item8_desc'),
            subs: [
                {
                    name: t('C_item8_list1_name'),
                    text: t('C_item8_list1_text'),
                },
                {
                    name: t('C_item8_list2_name'),
                    text: t('C_item8_list2_text'),
                },
                {
                    name: t('C_item8_list3_name'),
                    text: t('C_item8_list3_text'),
                },
            ],
            hoverImg: 'https://websiteoss.ecoflow.com/upload/image/1753685875605/3_8.jpg',
            productId: (() => {
                const map: any = {
                    eu: '9941723873623',
                    uk: '9824771014995',
                    de: '15094825550205',
                    fr: '9804551356763',
                    it: '14897221665144',
                    es: '9804554436955',
                };
                return map[locale] || undefined;
            })(),
            variantId: (() => {
                const map: any = {
                    eu: '50237886234967',
                    uk: '50632829337939',
                    de: '55582151442813',
                    fr: '50286346469723',
                    it: '54987797332344',
                    es: '50286359970139',
                };
                return map[locale] || undefined;
            })(),
            link_more: `https://${locale}.ecoflow.com/products/stream-balcony-solar-system`,
        },
        {
            title: t('C_item9_title'),
            desc: t('C_item9_desc'),
            subs: [
                {
                    name: t('C_item9_list1_name'),
                    text: t('C_item9_list1_text'),
                },
                {
                    name: t('C_item9_list2_name'),
                    text: t('C_item9_list2_text'),
                },
                {
                    name: t('C_item9_list3_name'),
                    text: t('C_item9_list3_text'),
                },
            ],
            hoverImg: 'https://websiteoss.ecoflow.com/upload/image/1753685874652/3_9.jpg',
            productId: (() => {
                const map: any = {
                    eu: '9963090837847',
                    uk: '9990081249619',
                    de: '15121742954877',
                    fr: '9822587027803',
                    it: '14899625886072',
                    es: '9822582505819',
                };
                return map[locale] || undefined;
            })(),
            variantId: (() => {
                const map: any = {
                    eu: '50319898444119',
                    uk: '51327074402643',
                    de: '55825223909757',
                    fr: '50343947567451',
                    it: '54999972643192',
                    es: '50343934951771',
                };
                return map[locale] || undefined;
            })(),
            link_more:
                locale === 'uk' ? 'https://uk.ecoflow.com/products/450w-rigid-solar-panel' : `https://${locale}.ecoflow.com/products/520w-rigid-solar-panel`,
        },
    ];
    const [gap, setGap] = useState<number>(12);

    const handleClickTab = (tab: string, k: number) => {
        setActive(k);
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: 'none',
            button_name: tab,
            __btn_id1: 'stream-ultra-x-C',
            __btn_id2: tab,
            __btn_type: 'text',
        });
    };

    const getAsynItem = async (item: any) => {
        const { productId, variantId } = item;
        return await new Promise(async (resolve, reject) => {
            try {
                const res = await getSolarRecommand({ productId, variantId }, locale);
                if (res?.code === '0') {
                    item.price = res?.data?.price;
                    item.compareAtPrice = res?.data?.compareAtPrice || res?.data?.price;
                    // item.link_more = res?.data?.handle ? `https://${locale}.ecoflow.com/${res?.data?.handle}` : '';
                    item.img = item?.img || res?.data?.variantImg || res?.data?.img;
                    item.link_more = `${item.link_more}?variant=${item.variantId}`;
                    return resolve(res);
                } else {
                    console.error(res?.message);
                    return reject(res?.message);
                }
            } catch (e) {
                console.error(e);
                return reject(e);
            }
        });
    };

    useEffect(() => {
        const arr = JSON.parse(JSON.stringify(products_static));
        const promises = arr?.map((item: any) => getAsynItem(item));
        Promise.all(promises)
            .then(() => {
                const a1 = arr.slice(0, 4);
                const a2 = arr.slice(4, 6);
                const a3 = arr.slice(6);
                setItems([a1, a2, a3]);
            })
            .catch((e) => {
                console.error(e);
            });

        if (typeof window !== 'undefined') {
            setGap(window.innerWidth > 1024 ? 24 : 12);

            const prev: HTMLDivElement | null = document.querySelector('.stream-ultra-x-C .swiper-button-prev');
            const next: HTMLDivElement | null = document.querySelector('.stream-ultra-x-C .swiper-button-next');
            const btnClick = (e: any) => {
                const button_name =
                    e?.target?.classList?.[0] === 'swiper-button-prev'
                        ? 'Left switch'
                        : e?.target?.classList?.[0] === 'swiper-button-next'
                        ? 'Right switch'
                        : '';
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'product_detail_page',
                    list_name: tabs[active],
                    button_name,
                });
            };
            if (prev) {
                prev.addEventListener('click', btnClick);
            }
            if (next) {
                next.addEventListener('click', btnClick);
            }
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const reset = () => {
                const doms = document.querySelectorAll(`.stream-ultra-x-C .swiper-box-${active} .item`) as NodeListOf<HTMLDivElement>;
                if (doms?.length > 0) {
                    let titleH = 0,
                        descH = 0,
                        subsH = 0;
                    for (let i = 0; i < doms.length; i++) {
                        const dom = doms[i];
                        const domTitle = dom.querySelector('.item-title') as HTMLElement;
                        const domDesc = dom.querySelector('.item-desc') as HTMLElement;
                        const domSubs = dom.querySelector('.item-subs') as HTMLElement;
                        titleH = Math.max(titleH, domTitle?.offsetHeight || 0);
                        descH = Math.max(descH, domDesc?.offsetHeight || 0);
                        subsH = Math.max(subsH, domSubs?.offsetHeight || 0);
                    }
                    for (let i = 0; i < doms.length; i++) {
                        const dom = doms[i];
                        const domTitle = dom.querySelector('.item-title') as HTMLElement;
                        domTitle.style.height = `${titleH}px`;
                        const domDesc = dom.querySelector('.item-desc') as HTMLElement;
                        domDesc.style.height = `${descH}px`;
                        const domSubs = dom.querySelector('.item-subs') as HTMLElement;
                        domSubs.style.height = `${subsH}px`;
                    }
                } else {
                    requestAnimationFrame(reset);
                }
            };
            reset();
        }
    }, [active]);

    return (
        <section
            className={`${css.section} stream-ultra-x-C GtmModuleData-section`}
            id="stream-ultra-x-C"
            data-section-id={'stream-ultra-x-C'}
            data-section-title={t('C_tab1')}
        >
            <div className="tabs-box">
                <ul className="tabs">
                    {tabs?.map((tab: string, k: number) => (
                        <li className={`GtmModuleData-btn-text tab${active === k ? ' active' : ''}`} key={tab} onClick={() => handleClickTab(tab, k)}>
                            {tab}
                        </li>
                    ))}
                </ul>
            </div>
            <ul className="swipers">
                {items?.map((lists: any[], m: number) => (
                    <li className={`swiper-box swiper-box-${m}${m === active ? ' active' : ''}`} key={m}>
                        <Swiper className="items" modules={[Navigation]} spaceBetween={gap} slidesPerView={'auto'} initialSlide={0} navigation={true}>
                            {lists?.map((item: any, k: number) => (
                                <SwiperSlide className={`item item-${k + 1}`} key={`${m}_${k}`}>
                                    <div className="item-img">
                                        <EcoImg className="img-p" pc={item.img} />
                                        <EcoImg className="img-h" pc={item.hoverImg} />
                                    </div>
                                    <div className="item-info">
                                        <div className="item-common">
                                            <p className="item-title">{item.title}</p>
                                            <p className="item-desc">{item.desc}</p>
                                            <ul className="item-subs">
                                                {item.subs?.map((sub: any, n: number) => (
                                                    <li className="item-sub" key={`${m}_${k}_${n}`}>
                                                        <p className="item-sub-name">{sub.name}</p>
                                                        <p className="item-sub-text">{sub.text}</p>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                        <div className="item-action">
                                            <div className="item-price">
                                                {item?.price > 0 && <span className="price-price">{FormatCurrencyLocal(item.price, locale)}</span>}
                                                {item?.price > 0 && item?.compareAtPrice && item?.price !== item?.compareAtPrice && (
                                                    <span className="price-compare">{FormatCurrencyLocal(item.compareAtPrice, locale)}</span>
                                                )}
                                            </div>
                                            <EcoLink
                                                className="item-link GtmModuleData-btn-href"
                                                href={item?.link_more}
                                                dataLayer={{
                                                    event: 'uaEvent',
                                                    event_name: 'buy',
                                                    product_name: item?.title,
                                                    position: `Product Detail_STREAM Ultra Series_${tabs[active]}`,
                                                    __btn_id1: `stream-ultra-x-C .item-${k + 1}`,
                                                    __btn_id2: item?.link_more || '',
                                                    __btn_type: 'href',
                                                }}
                                            >
                                                {t('C_learn_more')}
                                            </EcoLink>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </li>
                ))}
            </ul>
            <EcoLink
                className="option GtmModuleData-btn-href"
                href={`/${locale}/stream-series-energy-saving-calculator`}
                dataLayer={{
                    event: 'uaEvent',
                    event_name: 'jump_button',
                    position: `Product Detail_STREAM Ultra Series_${tabs[active]}`,
                    button_name: t('C_tip'),
                    url: `https://www.ecoflow.com/${locale}/stream-series-energy-saving-calculator`,
                    __btn_id1: `stream-ultra-x-C`,
                    __btn_id2: `/${locale}/stream-series-energy-saving-calculator`,
                    __btn_type: 'href',
                }}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
                    <path
                        d="M13.0162 4.57129H7.13258C5.9943 4.57129 5.07153 5.49405 5.07153 6.63234V12.516C5.07153 13.6543 5.9943 14.577 7.13258 14.577H13.0162C14.1545 14.577 15.0772 13.6543 15.0772 12.516V6.63234C15.0772 5.49405 14.1545 4.57129 13.0162 4.57129Z"
                        stroke="white"
                        strokeWidth="1.82857"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M13.0162 17.4199H7.13258C5.9943 17.4199 5.07153 18.3427 5.07153 19.481V25.3646C5.07153 26.5029 5.9943 27.4256 7.13258 27.4256H13.0162C14.1545 27.4256 15.0772 26.5029 15.0772 25.3646V19.481C15.0772 18.3427 14.1545 17.4199 13.0162 17.4199Z"
                        stroke="white"
                        strokeWidth="1.82857"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M25.8197 4.57129H19.936C18.7977 4.57129 17.875 5.49405 17.875 6.63234V12.516C17.875 13.6543 18.7977 14.577 19.936 14.577H25.8197C26.958 14.577 27.8807 13.6543 27.8807 12.516V6.63234C27.8807 5.49405 26.958 4.57129 25.8197 4.57129Z"
                        stroke="white"
                        strokeWidth="1.82857"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M25.8688 17.4199H19.9851C18.8468 17.4199 17.9241 18.3427 17.9241 19.481V25.3646C17.9241 26.5029 18.8468 27.4256 19.9851 27.4256H25.8688C27.007 27.4256 27.9298 26.5029 27.9298 25.3646V19.481C27.9298 18.3427 27.007 17.4199 25.8688 17.4199Z"
                        stroke="white"
                        strokeWidth="1.82857"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M8.25903 9.51955L9.5079 10.7684L11.8866 8.38965"
                        stroke="white"
                        strokeWidth="1.82857"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
                <span>{t('C_tip')}</span>
            </EcoLink>
        </section>
    );
};

export default C;
